import React from 'react';

import {assertAndContinue} from 'Asserts';
import {
  CanvasConfig,
  CanvasType,
  CanvasRenderer,
  CanvasTitleRenderer,
  CanvasTitleProps,
} from 'notebook/canvas/CanvasConstants';
import GridTitleContainer from 'notebook/canvas/GridTitle';
import {assertNever} from 'util/Types';

export default function getCanvasRenderer(
  canvasConfiguration: CanvasConfig,
  hideCanvasTitle?: boolean
):
  | {
      renderCanvas: CanvasRenderer | undefined;
      renderCanvasTitle: CanvasTitleRenderer | undefined;
    }
  | undefined {
  switch (canvasConfiguration.type) {
    case CanvasType.GRID:
      return {
        renderCanvas: undefined,
        renderCanvasTitle: hideCanvasTitle
          ? undefined
          : (props: CanvasTitleProps) => (
              <GridTitleContainer
                {...props}
                updateTitle={props.updateTitle ? props.updateTitle : async (newTitle: string) => {}}
                source={canvasConfiguration.source}
                parentApiIdentifier={canvasConfiguration.parentApiIdentifier}
                titleDisabled={props.titleDisabled}
              />
            ),
      };
    case CanvasType.NOTE:
      // Render content in the default text editor experience
      return {renderCanvas: undefined, renderCanvasTitle: undefined};
    default:
      assertAndContinue(false, `Unexpected canvas type: ${assertNever(canvasConfiguration.type)}`);
      return undefined;
  }
}
